import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    edit: translate({ id: 'settings.gpsAccount.view.edit' }),
    changePassword: translate({ id: 'settings.gpsAccount.view.changePassword' }),
  }))

  return api
}
